<template>

<div id="data-list-list-view" class="data-list-container">

    <vs-table ref="table" multiple v-model="selected" pagination @selected="showData" :max-items="itemsPerPage" search :data="itemsData">

      <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">

        <div class="flex flex-wrap-reverse items-center data-list-btn-container">

          <!-- ADD NEW -->
          <!-- <div class="btn-add-new p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-center text-lg font-medium text-base text-primary" @click="addItem">
              <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
              <span class="ml-2 text-base text-primary">Add New</span>
          </div> -->
           <vs-button color="primary" icon-pack="feather" icon="icon-plus" class="mr-4" @click="addItem">Add Item</vs-button>
        </div>

        <!-- ITEMS PER PAGE -->
        <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4 items-per-page-handler">
          <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
            <span class="mr-2">{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} - {{ itemsData.length - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : itemsData.length }} of {{ queriedItems }}</span>
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>
          <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
          <vs-dropdown-menu>

            <vs-dropdown-item @click="itemsPerPage=4">
              <span>4</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=10">
              <span>10</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=15">
              <span>15</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=20">
              <span>20</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>

      <template slot="thead">
        <vs-th sort-key="name">NAME</vs-th>
        <vs-th sort-key="beginning_balance">BEGINNING BALANCE</vs-th>
        <vs-th sort-key="ending_balance">ENDING BALANCE</vs-th>
        <vs-th sort-key="cashflow_counts">TOTAL CASHFLOW</vs-th>
        <vs-th>ACTION</vs-th>
      </template>

        <template slot-scope="{data}">
          <tbody>
            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">

              <vs-td>
                <p>{{ tr.name }}</p>
              </vs-td>
              <vs-td>
                <p>{{ tr.beginning_balance }}</p>
              </vs-td>
              <vs-td>
                <p>{{ tr.ending_balance }}</p>
              </vs-td>
              <vs-td>
                <p>{{ tr.cashflows_count }}</p>
              </vs-td>

              <vs-td class="whitespace-no-wrap">
                 <!-- <feather-icon icon="EyeIcon" svgClasses="w-5 h-5 hover:text-success stroke-current" @click.stop="showItem(tr)" /> -->
                <feather-icon icon="EditIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current" class="ml-2" @click.stop="editItem(tr)" />
                <feather-icon icon="TrashIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current" class="ml-2" @click.stop="confirmDeleteRecord(tr)" />
              </vs-td>

            </vs-tr>
          </tbody>
        </template>
    </vs-table>
    
    <!-- Popup Detail -->
    <vs-popup
      classContent="popup-example"
      title="Detail Bank Account"
      :active.sync="popupDetail"
      v-if="item"
    >
      <div class="vx-row">
        <div class="vx-col w-full lg:w-1/3">
          <h6 class="text-lg font-bold mb-2">Status</h6>
          <p>{{ item.status == 1 ? 'Active' : 'Inactive' }}</p>
        </div>
        <div class="vx-col w-full lg:w-1/3">
          <h6 class="text-lg font-bold mb-2">Branch Office</h6>
          <p>{{ item.branch_office }}</p>
        </div>
        <div class="vx-col w-full lg:w-1/3">
          <h6 class="text-lg font-bold mb-2">Total Cashflow</h6>
          <p>{{ item.cashflows_count }}</p>
        </div>
      </div>
    </vs-popup>

    <!--  Popup Form  -->
    <vs-popup classContent="popup-example" :title="`${mode} item`" :active.sync="popup">

      <div class="vx-row">
        <div class="vx-col md:w-1/1 w-full">
          <vs-input class="w-full mb-3" :label="$i18n.t('Name')" v-model="form.name" />
        </div>
        <!-- <div class="vx-col md:w-1/1 w-full">
          <vs-input class="w-full mb-3" :label="$i18n.t('CashBook Type')" v-model="form.cashbook_type" />
        </div> -->
        <div class="vx-col md:w-1/1 w-full">
          <vs-input class="w-full mb-3" :label="$i18n.t('Beginning Balance')" v-model="form.beginning_balance" />
        </div>
      </div>

      <div class="mt-5">
        <vs-button color="primary" type="filled" icon-pack="feather" icon="icon-save" @click="storeItem">
          {{ $i18n.t('Save') }}
        </vs-button>
      </div>

    </vs-popup>
  </div>

</template>

<script>
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
import vSelect from 'vue-select'
import moment from 'moment';
import axios from '@/axios.js';
// import axios from 'axios';

// Store Module
import moduleCashBook from '@/store/cashbooks/moduleCashBook.js'

export default {
  components: {
    vSelect,
  },
  data () {
    return {
      loaded: false,
      searchQuery: '',
      form: {},
      popup: false,
      popupDetail: false,
      mode: 'add',
      itemSelected: false,
      item: {},
      itemsData: [],
      moment: moment,
      
      selected: [],
      itemsPerPage: 5,
      isMounted: false,
    }
  },
  computed: {
    currentPage () {
      if (this.isMounted) {
        return this.$refs.table.currentx
      }
      return 0
    },
    queriedItems () {
      return this.$refs.table ? this.$refs.table.queriedResults.length : this.itemsData.length
    }
  },
  methods: {
    cashBookType() {
      const cashbookType = this.$route.params.cashbookType
 
      switch (cashbookType) {
        case "petty-cash":
          return 1
        case "big-cash":
          return 2
        case "mixed-cash":
          return 3
        default:
          break;
      }
    },
    getData () {
      const self = this

      self.itemsData = []

      this.$store.dispatch('cashBook/getCashBook', this.cashBookType()).then(res => {
        const data = res.data.data

        data.forEach((value, index) => {
          self.itemsData.push({
            id                : value.id,
            name              : value.name,
            beginning_balance : value.init_balance.toLocaleString(),
            ending_balance    : value.last_balance.toLocaleString(),
            cashflows_count   : value.cashflows_count,
          })
        })

        this.$vs.loading.close()
      }
      ).catch(err => {
        this.$vs.loading.close()
        this.$vs.notify({
          title:'Opps something error',
          text: err,
          color:'danger'
        })
      })
    },
    showItem (item) {
      axios.get('/api/v1/bank-account/' + item.id)
      .then(({data: res}) => {
        this.popupDetail = true
        this.item = res.data
      })
      .catch(err => console.error(err))
    },
    showData (item) {
      this.$router.push({ name: 'cash-book-cashflows', params: { cashbookType: this.$route.params.cashbookType, cashbookId: item.id }});
    },
    addItem () {
      this.popup = true;
      this.mode = 'add';
    },
    editItem (item) {
      this.popup = true;
      this.mode = 'edit';
      this.itemSelected = item;

      this.form = {
        name              : item.name,
        beginning_balance : item.beginning_balance.replaceAll(',',''),
      };
    },
    storeItem () {
      const userData  = this.$store.state.AppActiveUser

      if (this.mode == 'add') {
        let body = {
          company_id        : userData.company.id,
          cashbook_type     : this.cashBookType(),
          name              : this.form.name,
          init_balance      : this.form.beginning_balance,
        };

      this.$store.dispatch('cashBook/createCashBook', body)
        .then(res => {
          this.popup = false;
          this.$vs.notify({
            color: 'success',
            title: 'Successful',
            text: res.data.message
          })
          this.getData();
        }).catch(err => {
          this.popup = false;
          this.$vs.notify({
            title:'Opps something error',
            text: err.data.message,
            color:'danger'
          })
        })
      }
      else if (this.mode == 'edit') {
        const userData  = this.$store.state.AppActiveUser
        
        let body = {
          company_id        : userData.company.id,
          cashbook_type     : this.cashBookType(),
          name              : this.form.name,
          init_balance      : this.form.beginning_balance,
          _method: 'PUT',
        };

        this.$store.dispatch('cashBook/updateCashBook',{
          id: this.itemSelected.id,
          data: body
        })
        .then(res => {
          this.popup = false;

          this.$vs.notify({
            color: 'success',
            title: 'Successful',
            text: res.data.message
          })
          this.getData();
        }).catch(err => {
          this.popup = false;
          this.$vs.notify({
            title:'Opps something error',
            text: err.data.message,
            color:'danger'
          })
        })
      }

      this.mode = false;
    },
    confirmDeleteRecord (tr) {
      this.itemSelected = tr;
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Confirm Delete',
        text: `Do you want delete it?`,
        accept: this.deleteItem.bind(this),
        acceptText: 'Delete'
      })
    },
    deleteItem () { 
      this.$store.dispatch('cashBook/deleteCashBook', this.itemSelected.id).then(res => {
        this.$vs.notify({
            color: 'success',
            title: 'Successful',
            text: res.data.message
          })
        this.getData();
      }).catch(err => {
        this.$vs.notify({
          title:'Opps something error',
          text: err.data.message,
          color:'danger'
        })
      })
    },
  },
  mounted () {
   this.isMounted = true
  },
  watch: {
    $route () {
      this.getData();
    },
    popup () {
      if (!this.popup) {
        this.form = {};
      }
    }
  },
  created () {
    if (!moduleCashBook.isRegistered) {
      this.$store.registerModule('cashBook', moduleCashBook)
      moduleCashBook.isRegistered = true
    }
    this.getData();
    this.$vs.loading({
      text: `Wait a minute, It's getting data.`,
    })
  }
}
</script>

<style lang="scss">
#data-list-list-view {
  .vs-con-table {

    /*
      Below media-queries is fix for responsiveness of action buttons
      Note: If you change action buttons or layout of this page, Please remove below style
    */
    @media (max-width: 689px) {
      .vs-table--search {
        margin-left: 0;
        max-width: unset;
        width: 100%;

        .vs-table--search-input {
          width: 100%;
        }
      }
    }

    @media (max-width: 461px) {
      .items-per-page-handler {
        display: none;
      }
    }

    @media (max-width: 341px) {
      .data-list-btn-container {
        width: 100%;

        .dd-actions,
        .btn-add-new {
          width: 100%;
          margin-right: 0 !important;
        }
      }
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search{
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          &+i {
            left: 1rem;
          }

          &:focus+i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      // padding: 0 1rem;

      tr{
          box-shadow: 0 4px 20px 0 rgba(0,0,0,.05);
          td{
            padding: 20px;
            &:first-child{
              border-top-left-radius: .5rem;
              border-bottom-left-radius: .5rem;
            }
            &:last-child{
              border-top-right-radius: .5rem;
              border-bottom-right-radius: .5rem;
            }
          }
          td.td-check{
            display: none;
            padding: 20px !important;
          }
      }
    }

    .vs-table--thead{
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text{
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check{
        display: none;
        padding: 0 15px !important;
      }
      tr{
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>